import { IHelpCategory } from '../interfaces/help';
import { IResponse } from '../interfaces/response';
import request from './utils/request';

export const getHelpCategories = () =>
  request<void, IResponse<IHelpCategory[]>>({
    url: `/help_categories`,
    method: 'GET',
  });
